import { createContext, useContext, type ReactNode } from 'react';

import type {
  LoadFBXMesh,
  TransformLoadedMesh,
} from '../../r3f/hooks/useCharacterMeshWithCredentials';

export interface PlayerCharacterMeshOverrides {
  loadFBX?: LoadFBXMesh;
  createTransformLoadedMesh?: (meshPath: string) => TransformLoadedMesh;
}

const PlayerCharacterMeshContext = createContext<
  PlayerCharacterMeshOverrides | undefined
>(undefined);

export function PlayerCharacterMeshProvider({
  value,
  children,
}: {
  value?: PlayerCharacterMeshOverrides;
  children: ReactNode;
}) {
  return (
    <PlayerCharacterMeshContext.Provider value={value}>
      {children}
    </PlayerCharacterMeshContext.Provider>
  );
}

export function usePlayerCharacterMeshOverrides():
  | PlayerCharacterMeshOverrides
  | undefined {
  return useContext(PlayerCharacterMeshContext);
}
